// extracted by mini-css-extract-plugin
export var actionText = "_m7-4";
export var container = "_m7-0";
export var leftSection = "_m7-1";
export var rightSection = "_m7-2";
export var settingsButton = "_m7-6";
export var settingsIcon = "_m7-7";
export var shortcut = "_m7-5";
export var shortcutGroup = "_m7-3";